const axios = require("axios");
const store = require("store");
const cfg = require("../../darklaunch.config.json");
const socketIOClient = require("socket.io-client");
const mobx = require("mobx");

class Darklauncher {
  constructor() {
    this.configData = {};
    if (!this.loadData(cfg)) {
      return;
    }

    // Generate token, store locally, use in GET for tracking.
    if (cfg.settings.enableStreaming) {
      const socket = socketIOClient(cfg.settings.url, {
        query: {
          project_id: cfg.settings.project,
          api_version: cfg.version
        }
      });

      socket.on("state", data => {
        this.configs = data;
        console.log(data);
        store.set("darklaunch", this.configs);
      });

      socket.on("update", data => {
        console.log(data);
        Object.keys(data).forEach(key => {
          this.configs[key] = data[key];
        });
        store.set("darklaunch", this.configs);
      });
    } else {
      axios
        .get(
          `${cfg.settings.url}/api/darklaunch_bundle?project_id=${cfg.settings.project}&api_version=${cfg.version}`
        )
        .then(({ data }) => {
          data.map(darklaunch => {
            this.configs[darklaunch.code] = darklaunch.enabled;
          });
          const shouldRefresh =
            JSON.stringify(store.get("darklaunch")) !==
            JSON.stringify(this.configs);
          store.set("darklaunch", this.configs);
          if (shouldRefresh) {
            window.location.reload();
          }
        });
    }
  }

  loadData(cfg) {
    if (!cfg) {
      return false;
    }
    if (!cfg.settings.url) {
      cfg.settings.url = "https://www.darklaunch.me/";
    }
    mobx.extendObservable(this, {
      configs: store.get("darklaunch") || {},
      darklaunchID: store.get("darklaunchID") || {}
    });
    return true;
  }

  shouldRun(darklaunchFlag) {
    const darklookup = store.get("darklaunch") || {};
    if (darklookup[darklaunchFlag]) {
      let flag = darklookup[darklaunchFlag];
      if (!flag.enabled) {
        return false;
      }
      if (flag.rules != null && Object.keys(flag.rules).length > 0) {
        const rules = darklookup[darklaunchFlag].rules;
        return Object.keys(rules).reduce((outerAcc, ruleKey) => {
          return (
            outerAcc ||
            rules[ruleKey].reduce((innerAcc, rule) => {
              return innerAcc || rule === `${this.configData[ruleKey]}`;
            }, false)
          );
        }, false);
      } else {
        return darklookup[darklaunchFlag] || false;
      }
    }
    return false;
  }

  isEnabled(darklaunchFlag, cb) {
    let enabled = this.shouldRun(darklaunchFlag);
    if (cb && enabled) {
      return cb() || enabled;
    }
    return enabled;
  }

  setUser(uuid) {
    this.uuid = uuid;
    localStorage.setItem("darklaunchID", uuid);
  }

  config(loadedConfig) {
    this.configData = loadedConfig;
  }
}

module.exports = new Darklauncher(); // Support Require and Import
